module.exports = require('./m2ts');



// WEBPACK FOOTER //
// ./src/muxjs/m2ts/index.js